// import CatizTouchPanel from './CatizTouchPanel';

import CatizTouchPanel from 'nots-window-renderer/lib/Catiz3/TouchPanel';
import QueryString from 'query-string';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import System from '../../../config/SystemConfig';
import { CatizTabs, NotsSystem } from '../../../helpers/constants';
import useReportMonitorReady from '../../../hooks/useReportMonitorReady';
import actionService from '../../../store/actions.service';
import {
  listenInTab_AC,
  sendToParent_AC,
  touchPanelButtonClicked_AC,
  updateExecutionMode_AC,
} from '../../../store/actions/executor.actions';
import { DemoInteractionBlocker } from '../../common-components/DemoInteractionBlocker';
import GuidedContainer from '../../common-components/GuidedContainer';
import useLogger from '../../common-components/hooks/useLogger';
import { PauseOverlay } from '../../common-components/PauseOverlay';

const CATIZ_TSD_DEFINITION = 'CATIZ_TSD_DEFINITION';

export default function TouchPanel() {
  useLogger('Catiz3/TouchPanel/index.tsx', 'Catiz Touch panel');
  const dispatch = useDispatch();
  const location = useLocation();
  const jsonDefintion = useSelector(
    (state: any) => state.resources[CATIZ_TSD_DEFINITION]
  );
  const reportMonitorReady = useReportMonitorReady();

  useEffect(() => {
    System.setSystem(NotsSystem.CATIZ).setCurrentTab(CatizTabs.TOUCHPANEL);
  }, []);

  const { mode } = QueryString.parse(location.search);
  const executor = useSelector((state: any) => state.executor);
  const catiz = useSelector((state: any) => state.executor.catiz);

  const onTouchPanelClick = ({ id }: { id: any }) => {
    if (catiz.touchPanelLayoutMode !== 'cms') {
      dispatch(sendToParent_AC(touchPanelButtonClicked_AC(id)));
    } else {
      dispatch(
        sendToParent_AC(touchPanelButtonClicked_AC(id, CATIZ_TSD_DEFINITION))
      );
    }
  };

  useEffect(() => {
    if (mode) {
      dispatch(updateExecutionMode_AC(`${mode}`));
    }
  }, [mode]);

  useEffect(() => {
    reportMonitorReady('touchpanel');
    dispatch(listenInTab_AC());
  }, []);

  return (
    <div>
      <GuidedContainer />
      <PauseOverlay />
      <DemoInteractionBlocker />
      <CatizTouchPanel
        layoutId={catiz.touchPanelLayoutMode}
        jsonConfig={jsonDefintion}
        content={{
          mode,
          activeRole: executor.activeRole?.toUpperCase() ?? 'None',
          touchPanelState: executor.catiz.touchPanelState,
          tutorialArea: executor.catiz.tutorialArea,
          ...executor.catiz.content,
        }}
        buttonStatus={executor.catiz.touchPanelButtonStatus}
        textPanel={executor.catiz.textPanel}
        onClick={onTouchPanelClick}
        onButtonClick={(id: string) => onTouchPanelClick({ id })}
        actionService={actionService}
        dispatch={dispatch}
      />
    </div>
  );
}
